<template>
  <DashboardChartWrapper
    title="Paiements par mode"
    :loading="loading"
    :error="error"
    @retry="refresh"
  >
    <Doughnut v-if="chartData" :data="chartData" :options="chartOptions" />
  </DashboardChartWrapper>
</template>

<script setup>
import { computed } from 'vue'
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import { formatCurrency } from './helpers'
import DashboardChartWrapper from './DashboardChartWrapper.vue'

ChartJS.register(ArcElement, Tooltip, Legend)

const labelMap = {
  cash: 'Especes',
  card: 'Carte bancaire',
  mobile_money: 'Mobile Money',
  bank_transfer: 'Virement',
  check: 'Cheque',
  wallet: 'Portefeuille'
}

const colorMap = {
  cash: '#10b981',
  card: '#3b82f6',
  mobile_money: '#f59e0b',
  bank_transfer: '#8b5cf6',
  check: '#6b7280',
  wallet: '#ec4899'
}

const { dateParams } = useDateRange()
const { data, loading, error, refresh } = useDashboard('/dashboard/charts/sales-by-payment-method', dateParams)

const chartData = computed(() => {
  if (!data.value || !Array.isArray(data.value)) return null
  return {
    labels: data.value.map(d => labelMap[d.label] || d.label),
    datasets: [{
      data: data.value.map(d => d.total),
      backgroundColor: data.value.map(d => colorMap[d.label] || '#6b7280'),
      borderWidth: 2,
      borderColor: '#fff'
    }]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '60%',
  plugins: {
    legend: { position: 'bottom', labels: { usePointStyle: true, pointStyle: 'circle', padding: 16 } },
    tooltip: {
      callbacks: {
        label: (ctx) => `${ctx.label}: ${formatCurrency(ctx.raw)}`
      }
    }
  }
}
</script>
